import React, { useEffect, useState } from "react";
import {
  Pagination,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import axios from "axios";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { toast } from "react-toastify";
import AddIcon from "@mui/icons-material/Add";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormLabel from "@mui/material/FormLabel";
import { baseUrl } from "../../config/axios";

const ProductCategory = () => {
  const [countryData, setCountryData] = useState([]);
  const [stateData, setStateData] = useState([]);
  const [cityData, setCityData] = useState([]);
  const [countryId, setCountryId] = useState(108);
  const [stateId, setStateId] = useState("");
  const [cityId, setCityId] = useState("");
  // start the game
  const [data, setData] = useState([]);
  const [storeData, setStoreData] = useState([]);
  // end the game
  const [amount, setAmount] = React.useState("");
  const [delTime, setDelTime] = React.useState("");
  const [cod, setCod] = React.useState("");
  const [available, setAvailable] = React.useState("");
  const [page, setPage] = useState(1)
  const [searchQuery, setSearchQuery] = useState("")

  const countryDataList = () => {
    axios
      .get(`${baseUrl}api/country-list/`, {
        headers: {
          Token: localStorage.getItem("Token"),
        },
      })
      .then((response) => {
        console.log("country list data===>", response?.data?.data);
        setCountryData(response?.data?.data);
      })
      .catch((error) => {
        console.log("", error);
      });
  };
  useEffect(() => {
    countryDataList();
  }, []);

  const stateList = () => {
    axios
      .get(`${baseUrl}api/state-list/?country_id=${countryId}`, {
        headers: {
          Token: localStorage.getItem("Token"),
        },
      })
      .then((response) => {
        console.log("country list data===>", response?.data?.data);
        setStateData(response?.data?.data);
      })
      .catch((error) => {
        console.log("", error);
      });
  };

  useEffect(() => {
    countryId && stateList();
  }, [countryId]);

  const cityDataList = () => {
    axios
      .post(
        `${baseUrl}api/city-list/`,
        { state_id: stateId },
        {
          headers: {
            Token: localStorage.getItem("Token"),
          },
        }
      )
      .then((response) => {
        console.log("country list data===>", response?.data?.data);
        setCityData(response?.data?.data);
      })
      .catch((error) => {
        console.log("", error);
      });
  };

  useEffect(() => {
    stateId && cityDataList();
  }, [stateId]);

  const cityBasedPincodeDataList = () => {


    axios
      .post(
        `${baseUrl}api/admin/get-all-pincode-data/`,
        { city_id: cityId, page: page, search_values: searchQuery },
        {
          headers: {
            Token: localStorage.getItem("Token"),
          },
        }
      )
      .then((response) => {
        setData(response?.data);
        console.log(response?.data, "res====>");
      })
      .catch((error) => {
        console.log("", error);
      });
  };

  useEffect(() => {
    cityBasedPincodeDataList();
  }, [cityId, page, searchQuery]);

  const updateFun = (row) => {
    const fd = new FormData()
    fd.append("pincode_id", row?.id)
    fd.append("delivery_time", delTime ? delTime : row?.delivery_time)
    fd.append("delivery_amount", amount ? amount : row?.delivery_amount)
    fd.append("is_delivery_aviable", available ? available : row?.is_delivery_available ? "True" : "False")
    fd.append("is_cod_available", cod ? cod : row?.is_cod_available ? "True" : "False");
    axios
      .post(
        `${baseUrl}api/admin/update-pincode-data-specification/`,
        fd,
        {
          headers: {
            Token: localStorage.getItem("Token"),
          },
        }
      )
      .then((response) => {
        toast.success(response?.data?.message);
        setAmount("")
        setDelTime("")
        setAvailable("")
        setCod("")
        cityBasedPincodeDataList()
      })
      .catch((error) => {
        console.log("", error);
      });
  };

  const handleChange = (event, value) => {
    setPage(value);
  };


  return (
    <div className=" !bg-slate-100">
      <div className="flex justify-between">
        <div className="p-2">
          <p className="text-xl !text-black font font-bold">
            Manage Delivery Pincode List
          </p>
        </div>
        <div className="p-2 pt-5">{/* <CreateResellers /> */}</div>
      </div>

      <div className="flex justify-between gap-x-2">
        <div className="flex flex-col p-4 w-[27%] h-96 !rounded !text-black bg-slate-100 shadow-card shadow-zinc-600 ml-2">
          <div className="text-center font-bold text-xl">Choose Your Field</div>
          <div>
            <div className="py-2">Select Country :</div>
            <FormControl fullWidth>
              <Select
                size="small"
                className="mt-1"
                value={countryId}
                onChange={(e) => setCountryId(e.target.value)}
                name="productId"
              >
                {countryData?.map((elem) => (
                  <MenuItem value={elem?.id}>{elem?.country}</MenuItem>
                ))}
              </Select>
            </FormControl>

            <div className="py-2">Select State :</div>
            <FormControl fullWidth>
              <Select
                size="small"
                className="mt-1"
                onChange={(e) => setStateId(e.target.value)}
                name="productId"
              >
                {stateData?.map((elem) => (
                  <MenuItem value={elem?.id}>{elem?.state}</MenuItem>
                ))}
              </Select>
            </FormControl>
            <div className="py-2">Select City :</div>
            <FormControl fullWidth>
              <Select
                size="small"
                className="mt-1"
                onChange={(e) => setCityId(e.target.value)}
                name="productId"
              >
                {cityData?.map((elem) => (
                  <MenuItem value={elem?.id}>{elem?.city}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
        </div>
        <div className="flex flex-col !rounded w-[70%] h-[81vh] !text-black bg-slate-100 shadow-card shadow-zinc-600 mr-2">
          <div className="flex justify-between p-2">
            <div>
              <input
                class="placeholder:italic placeholder:text-slate-400 block bg-white w-80 border border-slate-300 rounded-md py-2 px-2 pr-3 shadow-sm focus:outline-none focus:border-slate-600 focus:ring-slate-500 focus:ring-1 sm:text-sm"
                placeholder="Search for anything..."
                type="text"
                name="search"
                // value={searchQuary}
                onChange={(event) => setSearchQuery(event.target.value)}
              />

            </div>
            <div>

            </div>
          </div>
          <TableContainer
            component={Paper}
            // sx={{  }}
            sx={{ width: "100%", maxHeight: "80vh" }}
            className="!text-black !mx-auto !bg-white overflow-y-auto"
          >
            <Table stickyHeader aria-label="sticky table" size="small">
              <TableHead>
                <TableRow>
                  <TableCell
                    style={{
                      borderRight: "1px solid #D0D0D0",
                      fontFamily: "'Poppins', sans-serif",
                    }}
                    className="!text-center !text-gray-800 !font-bold"
                  >
                    ID
                  </TableCell>
                  <TableCell
                    style={{
                      borderRight: "1px solid #D0D0D0",
                      fontFamily: "'Poppins', sans-serif",
                    }}
                    className="!text-center !text-gray-800 !font-bold"
                  >
                    CITY
                  </TableCell>
                  <TableCell
                    style={{
                      borderRight: "1px solid #D0D0D0",
                      fontFamily: "'Poppins', sans-serif",
                    }}
                    className="!text-center !text-gray-800 !font-bold"
                  >
                    PINCODE
                  </TableCell>
                  <TableCell
                    style={{
                      borderRight: "1px solid #D0D0D0",
                      fontFamily: "'Poppins', sans-serif",
                    }}
                    className="!text-center !text-gray-800 !font-bold"
                  >
                    <div className="w-40">DELIVERY AMOUNT</div>

                  </TableCell>
                  <TableCell
                    style={{
                      borderRight: "1px solid #D0D0D0",
                      fontFamily: "'Poppins', sans-serif",
                    }}
                    className="!text-center !text-gray-800 !font-bold"
                  >

                    <div className="w-44">DELIVERY TIME</div>
                  </TableCell>
                  <TableCell
                    style={{
                      borderRight: "1px solid #D0D0D0",
                      fontFamily: "'Poppins', sans-serif",
                    }}
                    className="!text-center !text-gray-800 !font-bold"
                  >
                    <div className="w-44">IS CODE AVAILABLE</div>
                  </TableCell>
                  <TableCell
                    style={{
                      borderRight: "1px solid #D0D0D0",
                      fontFamily: "'Poppins', sans-serif",
                    }}
                    className="!text-center !text-gray-800 !font-bold"
                  >
                    <div className="w-44">IS DELIVERY AVAILABLE</div>
                  </TableCell>
                  <TableCell
                    style={{
                      borderRight: "1px solid #D0D0D0",
                      fontFamily: "'Poppins', sans-serif",
                    }}
                    className="!text-center !text-gray-800 !font-bold"
                  >
                    UPDATE
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody className="!bg-white bg-opacity-50">
                {data?.data &&
                  data?.data?.map((row, index) => (
                    <TableRow key={row.id} className="!text-slate-700">
                      <TableCell
                        className="!text-center !text-[12px]"
                        style={{
                          borderRight: "1px solid #D0D0D0",
                          fontFamily: "'Poppins', sans-serif",
                        }}
                      >
                        <span>{index + 1}</span>
                        {/* <Checkbox
                          {...label}
                          onChange={(event) => submitData(event, row?.pincode)}
                        /> */}
                      </TableCell>
                      <TableCell
                        className="!text-center !text-[12px]"
                        style={{
                          borderRight: "1px solid #D0D0D0",
                          fontFamily: "'Poppins', sans-serif",
                        }}
                      >
                        {row?.city_name ? row?.city_name : "--"}
                      </TableCell>
                      <TableCell
                        className="!text-center !text-[12px]"
                        style={{
                          borderRight: "1px solid #D0D0D0",
                          fontFamily: "'Poppins', sans-serif",
                        }}
                      >
                        {row?.pincode ? row?.pincode : "--"}
                      </TableCell>
                      <TableCell
                        className="!text-center !text-[12px]"
                        style={{
                          borderRight: "1px solid #D0D0D0",
                          fontFamily: "'Poppins', sans-serif",
                        }}
                      >
                        <input
                          size="small"
                          defaultValue={
                            row?.delivery_amount ? row?.delivery_amount : "--"
                          }
                          onChange={(e) => setAmount(e.target.value)}
                          className="!w-[100%] !mt-1 border rounded border-gray-300 p-1"
                        />
                      </TableCell>
                      <TableCell
                        className="!text-center !text-[12px]"
                        style={{
                          borderRight: "1px solid #D0D0D0",
                          fontFamily: "'Poppins', sans-serif",
                        }}
                      >
                        <input
                          size="small"
                          type="text"
                          defaultValue={row?.delivery_time ? row?.delivery_time : "--"}
                          onChange={(e) => setDelTime(e.target.value)}
                          className="!w-[100%] !mt-1 border rounded border-gray-300 p-1"
                        />
                      </TableCell>
                      <TableCell
                        className="!text-center !text-[12px]"
                        style={{
                          borderRight: "1px solid #D0D0D0",
                          fontFamily: "'Poppins', sans-serif",
                        }}
                      >
                        <FormControl>
                          <RadioGroup
                            row
                            defaultValue={
                              row?.is_cod_available ? "True" : "False"
                            }
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            size="small"
                            onChange={(e) => setCod(e.target.value)}
                          >
                            <FormControlLabel
                              value={"True"}
                              control={<Radio />}
                              label={"True"}
                            />
                            <FormControlLabel
                              value={"False"}
                              control={<Radio />}
                              label={"False"}
                            />
                          </RadioGroup>
                        </FormControl>
                      </TableCell>
                      <TableCell
                        className="!text-center !text-[12px]"
                        style={{
                          borderRight: "1px solid #D0D0D0",
                          fontFamily: "'Poppins', sans-serif",
                        }}
                      >
                        <FormControl>
                          <RadioGroup
                            row
                            defaultValue={
                              row?.is_delivery_available ? "True" : "False"
                            }
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            size="small"
                            onChange={(e) => setAvailable(e.target.value)}
                          >
                            <FormControlLabel
                              value="True"
                              control={<Radio />}
                              label="True"
                            />
                            <FormControlLabel
                              value="False"
                              control={<Radio />}
                              label="False"
                            />
                          </RadioGroup>
                        </FormControl>
                      </TableCell>
                      <TableCell
                        className="!text-center !text-[12px]"
                        style={{
                          borderRight: "1px solid #D0D0D0",
                          fontFamily: "'Poppins', sans-serif",
                        }}
                      >
                        <button onClick={() => updateFun(row)}>
                          <AddIcon />
                        </button>
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>

          </TableContainer>
          {data?.data ? (
            <div className="flex justify-center p-2">
              <Pagination
                page={data?.current_page}
                size="small"
                count={data?.total_pages}
                variant="outlined"
                color="primary"
                onChange={handleChange}
              />
            </div>
          )
            :
            <div class="spinner"></div>

          }
        </div>
      </div>
    </div>
  );
};

export default ProductCategory;
